import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import r1 from "../components/Images/rentcar.png";
import sl1 from "../components/Images/sl1.png";
import sl2 from "../components/Images/sl2.png";
import sl3 from "../components/Images/sl3.png";
import "../Rentcar.css";
const RentCar = () => {
  return (
    <>
      <div className="container my-5">
        {/* Steps Section */}
        <div className="row align-items-center">
          <div className="col-md-6 text-center">
            <img
              src={r1} // replace with actual image path
              alt="Car"
              className="img-fluid"
            />
          </div>
          <div className="col-md-6">
            <h2 className="fw-bold">Rent Our Cars in 3 Steps</h2>
            <p >
              Check how it Works to Rent Cars in DreamsRent
            </p>
            <div className="d-flex mb-4">
              <div className="me-3 fs-2 text-warning">
                <i className="bi bi-calendar-event"></i>
              </div>
              <div>
                <h5 className="fw-bold">Choose Date & Locations</h5>
                <p >
                  Determine the date & location for your car rental. Consider
                  factors such as your travel itinerary, pickup/drop-off
                  locations.
                </p>
              </div>
            </div>
            <div className="d-flex mb-4">
              <div className="me-3 fs-2 text-info">
                <i className="bi bi-geo-alt"></i>
              </div>
              <div>
                <h5 className="fw-bold">Select Pick-Up & Drop Locations</h5>
                <p >
                  Check the availability of your desired vehicle type. Ensure
                  rental rates, taxes, fees, and extra charges.
                </p>
              </div>
            </div>
            <div className="d-flex">
              <div className="me-3 fs-2 text-dark">
                <i className="bi bi-car-front-fill"></i>
              </div>
              <div>
                <h5 className="fw-bold">Book your Car</h5>
                <p >
                  Determine the date & location for your car rental. Consider
                  factors such as your travel itinerary, pickup/drop-off
                  locations.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Stats Section */}
        <div className="row text-center text-white bg-dark mt-5 rounded py-4">
          <div className="col-6 col-md-3 mb-3">
            <h4 className="fw-bold">16K+</h4>
            <p>Happy Customers</p>
          </div>
          <div className="col-6 col-md-3 mb-3">
            <h4 className="fw-bold">2547K+</h4>
            <p>Count of Cars</p>
          </div>
          <div className="col-6 col-md-3 mb-3">
            <h4 className="fw-bold">625K+</h4>
            <p>Locations to Pickup</p>
          </div>
          <div className="col-6 col-md-3 mb-3">
            <h4 className="fw-bold">15000K+</h4>
            <p>Total Kilometers</p>
          </div>
        </div>
      </div>
      <section className="carousel-bg">
       <div className="text-center mb-4 text-black">
        <h2>🌟 <strong>Popular Cars On Recommendations</strong> 🌟</h2>
        <p>Here are some versatile options that cater to different needs</p>
      </div>

        <div
          id="carCarousel"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          <div className="carousel-inner">
            {/* Slide 1 */}
            <div className="carousel-item active text-center">
              <h6 >FORD</h6>
              <h1 className="fw-bold custom-carname">MUSTANG</h1>
              <img
                src={sl1}
                className="car-image"
                alt="Mustang"
              />
              <div className="price-tag">
                <small>Starts From</small>
                <div>
                  <strong>$650</strong>{" "}
                  <span style={{ fontSize: "0.8rem" }}>/day</span>
                </div>
              </div>
            </div>

            {/* Slide 2 */}
            <div className="carousel-item text-center">
              <h6 >AUDI</h6>
              <h1 className="fw-bold custom-carname">A3 2024 New</h1>
              <img
                src={sl2}
                className="car-image"
                alt="Tesla"
              />
              <div className="price-tag">
                <small>Starts From</small>
                <div>
                  <strong>$700</strong>{" "}
                  <span style={{ fontSize: "0.8rem" }}>/day</span>
                </div>
              </div>
            </div>
            {/* Slide 3 */}
            <div className="carousel-item text-center">
              <h6 >TOYOTO</h6>
              <h1 className="fw-bold custom-carname">CAMREY SE 350</h1>
              <img
                src={sl3}
                className="car-image"
                alt="Tesla"
              />
              <div className="price-tag">
                <small>Starts From</small>
                <div>
                  <strong>$700</strong>{" "}
                  <span style={{ fontSize: "0.8rem" }}>/day</span>
                </div>
              </div>
            </div>
          </div>

          {/* Controls */}
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#carCarousel"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon bg-dark rounded-circle"></span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#carCarousel"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon bg-dark rounded-circle"></span>
          </button>
        </div>
      </section>
      {/* pricing card section */}
       <div className="container py-5">
      <div className="text-center mb-5">
        <h2 className="fw-bold">🌟 Best Pricing in Rental 🌟</h2>
        <p className="text-muted">Choose the Right Plan for Your Business</p>
      </div>

      <div className="row g-4">
        {/* Starter Plan */}
        <div className="col-md-3">
          <div className="card h-100 shadow-sm text-center">
            <div className="card-body">
              <h5 className="fw-bold">Stater</h5>
              <h2 className="text-dark">$299</h2>
              <p className="text-muted">Per Month</p>
              <span className="badge bg-danger mb-2">30% Offer</span>
              <ul className="list-unstyled mt-3">
                <li>✨ 50% Downpayment</li>
                <li>✨ Insurance not Included</li>
                <li>✨ Doorstep Not Included</li>
                <li>✨ Roadside Assistance</li>
                <li>✨ Minimal Insurance Coverage</li>
                <li>✨ Additional Perks - GPS</li>
                <li>✨ No Flexible timing & extension</li>
              </ul>
            </div>
            <div className="card-footer bg-transparent">
              <button className="btn btn-dark w-100">Choose Plan →</button>
            </div>
          </div>
        </div>

        {/* Premium Plan */}
        <div className="col-md-3">
          <div className="card h-100 shadow-sm text-center">
            <div className="card-body">
              <h5 className="fw-bold">Premium</h5>
              <h2 className="text-dark">$1299</h2>
              <p className="text-muted">Per Month</p>
              <span className="badge bg-pink text-white mb-2">100% Offer</span>
              <ul className="list-unstyled mt-3">
                <li>✨ 25% Downpayment</li>
                <li>✨ Insurance Included</li>
                <li>✨ Doorstep Delivery Available</li>
                <li>✨ Roadside Assistance</li>
                <li>✨ Personal Injury Protection</li>
                <li>✨ GPS, Car Seat Perks</li>
                <li>✨ Flexible timing & extension</li>
              </ul>
            </div>
            <div className="card-footer bg-transparent">
              <button className="btn btn-dark w-100">Choose Plan →</button>
            </div>
          </div>
        </div>

        {/* Enterprise Plan */}
        <div className="col-md-3">
          <div className="card h-100 shadow-sm text-center border-info">
            <div className="card-body position-relative">
              <h5 className="fw-bold">Enterprise</h5>
              <h2 className="text-dark">$1599</h2>
              <p className="text-muted">Per Month</p>
              <span className="badge bg-info text-dark position-absolute top-0 end-0 mt-2 me-2">
                Recommended
              </span>
              <ul className="list-unstyled mt-3">
                <li>✨ 0% Downpayment</li>
                <li>✨ Insurance Included</li>
                <li>✨ Doorstep Delivery Available</li>
                <li>✨ Roadside Assistance</li>
                <li>✨ Personal Injury Protection</li>
                <li>✨ GPS, Car Seat Perks</li>
                <li>✨ Flexible timing & extension</li>
              </ul>
            </div>
            <div className="card-footer bg-transparent">
              <button className="btn btn-dark w-100">Choose Plan →</button>
            </div>
          </div>
        </div>

        {/* Custom Plan */}
        <div className="col-md-3">
          <div className="card h-100 text-white text-center" style={{ backgroundColor: '#00C851' }}>
            <div className="card-body">
              <h5 className="fw-bold">Custom</h5>
              <h2>Contact Us</h2>
              <ul className="list-unstyled mt-3">
                <li>✨ Weekend/Weekly Deals</li>
                <li>✨ Membership Discounts</li>
                <li>✨ Insurance Upgrades</li>
                <li>✨ Personal Accident Insurance</li>
                <li>✨ Minimal Insurance Coverage</li>
                <li>✨ No Long Term Commitment</li>
                <li>✨ Refundable Deposit</li>
                <li>✨ Priority Service</li>
              </ul>
            </div>
            <div className="card-footer bg-transparent">
              <button className="btn btn-light w-100 text-dark">Choose Plan →</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default RentCar;
